import { useFeatureFlagsContext } from "src/context/FeatureFlagsContext";

/** Convenience hook for a single flag. */
export const useFeatureFlag = (key: string): boolean => {
    const { enabledFeatures } = useFeatureFlagsContext();
    return enabledFeatures.includes(key);
};

/**
 * Full feature-flags hook. Use this when you need to gate UI on whether the
 * /features call has resolved (or timed out), or when you need to pass the
 * current set of enabled features into a non-React layer (e.g. a DAO).
 */
export const useFeatureFlags = () => {
    const { enabledFeatures, ready, degraded, loaded } = useFeatureFlagsContext();
    return { enabledFeatures, ready, degraded, loaded };
};
